const menu = {
  key: "counties",
  route: "/legacy/counties",
  label: "sidebar.counties",
  icon: "faMapLocationDot",
  group: "masterdata",
  order: 30,
  permission: "legacy.counties.read"
};

export default menu;